import { MarkdownRenderer } from '@web/ui';

type LegalTermsPanelProps = {
  markdownContent: string;
};

export function LegalTermsPanel({ markdownContent }: LegalTermsPanelProps) {
  return (
    <div
      className="card-container-glass"
      style={{
        margin: '0 auto',
        padding: '1rem 1.25rem',
      }}
    >
      <MarkdownRenderer markdownContent={markdownContent} showLogo />
    </div>
  );
}
